var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYouTubeShorts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.577.353c1.509-.787 3.377-.214 4.172 1.28a3.04 3.04 0 0 1-1.295 4.127l-1.24.653a3.09 3.09 0 0 1 2.622 1.63 3.04 3.04 0 0 1-1.294 4.127l-6.617 3.477c-1.51.786-3.378.213-4.172-1.28a3.04 3.04 0 0 1 1.294-4.128l1.24-.652a3.09 3.09 0 0 1-2.622-1.63A3.04 3.04 0 0 1 1.96 3.829zM5.005 5.538 9.01 8.01l-4.005 2.461z",
  clipRule: "evenodd"
})));
export default SvgYouTubeShorts;